export const getCommentsFromState = state => state.comments.list;
export const getCommentFromState = state => state.comments.selectedItem;
export const getFileUrl = state => state.comments.selectedFileUrl;
export const getUploadProgressPercentage = state => state.comments.uploadProgress;
export const getAuthenticatedUser = state => state.auth.user;
